import toast from "react-hot-toast";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getConfig = () => {
  const user = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const token = user?.data?.token || "";

  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

export const viewCategoryList = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RESALE_CATEGORY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/resale-category/list`,
        categoryData,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RESALE_CATEGORY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
        return data;
      } else {
        dispatch({ type: "GET_RESALE_CATEGORY_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_RESALE_CATEGORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewSCategoryList = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_RESALE_CATEGORY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/resale-category/list`,
        categoryData,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_RESALE_CATEGORY_LIST_SUCCESS", payload: data });
        dispatch({ type: "SET_FETCH_TIME", payload: Date.now() });
        return data;
      } else {
        dispatch({ type: "GET_RESALE_CATEGORY_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_RESALE_CATEGORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addNewCategory = (categoryData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_RESALE_CATEGORY_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/resale-category/add`,
        categoryData,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_RESALE_CATEGORY_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_RESALE_CATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_RESALE_CATEGORY_FAILED",
        payload: error?.response?.data,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

export const editCategory = (categoryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_RESALE_CATEGORY_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/resale-category/update`,
        categoryData,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_RESALE_CATEGORY_SUCCESS", payload: data });
        toast.success("Edited Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_RESALE_CATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_RESALE_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCategory = (categoryId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_RESALE_CATEGORY_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/resale-category/${categoryId}`,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_RESALE_CATEGORY_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_RESALE_CATEGORY_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "VIEW_RESALE_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewSubCategoryList = (subCategoryData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_RESALE_SUB_CATEGORY_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/resale-category/list`,
        subCategoryData,
        getConfig()
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_RESALE_SUB_CATEGORY_LIST_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "GET_RESALE_SUB_CATEGORY_LIST_FAILED",
          payload: data,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_RESALE_SUB_CATEGORY_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    }
  };
};